// src/app/App.tsx
import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import AppRoutes from './routes'
import Navbar from '../components/ui/Navbar'
import Footer from '../components/ui/Footer'
import { AuthProvider } from '../hooks/useAuth'
import { LanguageProvider } from '../contexts/LanguageContext'

const queryClient = new QueryClient()

export default function App() {
  // Suppress the browser context menu on media only (images/videos), so the
  // "Open image/video in new tab" / "Save" options don't appear. Right-click
  // on text, links, inputs, etc. is left untouched to avoid breaking anything.
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      const target = e.target as Element | null
      if (target?.closest('img, video')) {
        e.preventDefault()
      }
    }
    document.addEventListener('contextmenu', handleContextMenu)
    return () => document.removeEventListener('contextmenu', handleContextMenu)
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Navbar />
            <AppRoutes />
            <Footer />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  )
}
